export default {
  en: {
    'pages.org-structure.entity-info.heading': 'Entity',
    'pages.org-structure.entity-info.sub-heading':
      'You are set up for a single entity. Contact your administrator if you wish to switch to a group entity',
    'pages.org-structure.entity-options.heading': 'Entities',
    'pages.org-structure.entity-options.sub-heading': 'What best describes your company structure?',
    'pages.org-structure.entity-options.single-entity': 'Single entity',
    'pages.org-structure.entity-options.single-entity.description':
      'A single company established in one country',
    'pages.org-structure.entity-options.group-entity': 'Group',
    'pages.org-structure.entity-options.group-entity.description':
      'One group with multiple entities',
    'pages.org-structure.single-entity.form.heading': 'Enter your entity details',
    'pages.org-structure.single-entity.form.sub-heading':
      'You will be set up for a single entity. If you have more entities you can switch to a group set up',
    'pages.org-structure.group.form.heading': 'Add an entity',
    'pages.org-structure.group.form.edit-heading': 'Update {entityName}',
    'pages.org-structure.group.form.sub-heading': 'You do not have any entities. Try adding some.',
    'pages.org-structure.group.form.search-placeholder': 'Search organisations',
    'pages.org-structure.group.form.label.team': 'Team',
    'pages.org-structure.group.form.label.team.placeholder': 'Select a team',
    'pages.org-structure.group.form.label.name': 'Name this entity',
    'pages.org-structure.group.form.label.company-name': 'Company Name',
    'pages.org-structure.group.form.label.address': 'Address',
    'pages.org-structure.group.form.label.name.placeholder': 'Entity name',
    'pages.org-structure.group.form.label.address.placeholder': 'Address',
    'pages.org-structure.group.form.label.tax-number': 'Tax number',
    'pages.org-structure.group.form.label.city': 'City',
    'pages.org-structure.group.form.label.tax-number.placeholder': 'Tax number',
    'pages.org-structure.group.form.label.city.placeholder': 'City',
    'pages.org-structure.group.form.label.country': 'Country of establishment',
    'pages.org-structure.group.form.label.zip-code': 'Postal code',
    'pages.org-structure.group.form.label.country.placeholder': 'Country of establishment',
    'pages.org-structure.group.form.label.zip-code.placeholder': 'Postal code',
  },
};
